module.exports = __webpack_public_path__ + "media/components/country-flag/static/de-8a3b491227c375bfe8cb7b2eeb44701d.svg";